export const publicVersion = "2.8.1-23-g3e064e2d-2026-05-23T15-50-50Z";